const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "TIME_RECORD_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "TIME_RECORD_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "TIME_RECORD_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};